<template>
  <div class="m-edition-section-content-info">
    <h2 class="m-edition-section-content-info-subtitle">
      <span class="m-edition-section-content-info-subtitle-academy-name">
        Vidroop Ventas
      </span>
      <i class="fas fa-angle-right"></i>
      <span>
        {{ infoTitle }}
      </span>
      <span v-if="infoSubTitle">
        <i class="fas fa-angle-right"></i>
        <span>
          {{ infoSubTitle }}
        </span>
      </span>
    </h2>
    <div class="m-edition-section-content-info-title">
      <h1>
        {{ infoEdition }}
      </h1>
      <a
        v-show="goBackText"
        href="#"
        @click.prevent="$router.go(-1)"
      >
        <i class="fas fa-arrow-left"></i>
        {{ goBackText }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionSectionContentInfo',

  props: {
    goBackText: String,
    infoTitle: String,
    infoSubTitle: String,
    section: String,
    subject: String
  },

  computed: {
    infoEdition () {
      return this.infoSubTitle ? this.infoSubTitle : this.infoTitle
    }
  }
}
</script>
